const unStableCurrencyList = ['BTC'];

export const isShowFiatPrice = (coinType) => (unStableCurrencyList.indexOf(coinType) > -1);

export default isShowFiatPrice;
